import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { api } from "../../lib/api";

export const creditsChanged = () => window.dispatchEvent(new Event("credits-changed"));

export function useCreditBalance() {
  const loc = useLocation();
  const [b, setB] = useState(null);
  useEffect(() => {
    const load = () => api.get("/credits/balance").then((r) => setB(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("credits-changed", load);
    return () => { clearInterval(t); window.removeEventListener("credits-changed", load); };
  }, [loc.pathname]);
  return b;
}

export function LowCreditBanner() {
  const loc = useLocation();
  const b = useCreditBalance();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("lowCreditHidden") || "");
  if (!b || b.unlimited || b.balance >= 10 || loc.pathname === "/app/billing") return null;
  const out = b.balance <= 0;
  const state = out ? "out" : "low";
  if (hidden === state) return null;
  return (
    <div className={`mb-6 rounded-lg border px-4 py-3 flex flex-wrap items-center gap-3 fade-up ${out ? "border-red-700/70 bg-red-950/40" : "border-amber-600/60 bg-amber-950/30"}`} data-testid="low-credit-banner">
      <AlertTriangle size={16} className={out ? "text-red-400" : "text-amber-400"} />
      <p className="text-sm flex-1 min-w-[200px]">{out ? "You're out of AI credits — AI actions are paused." : <>Only <span className="font-semibold" data-testid="low-credit-balance">{b.balance.toLocaleString()}</span> AI credits left.</>}</p>
      <Link to="/app/billing#packs" className="glow-btn bg-amber-600 hover:bg-amber-500 text-white text-sm px-4 py-1.5 rounded-md transition-colors" data-testid="low-credit-topup">Top up</Link>
      <button onClick={() => { sessionStorage.setItem("lowCreditHidden", state); setHidden(state); }} className="text-slate-400 hover:text-white" aria-label="Dismiss" data-testid="low-credit-dismiss"><X size={15} /></button>
    </div>
  );
}
